class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelectorAll('[name="add"] .p-add-cart-btn');
    const productInventory = this.currentVariant.inventory_quantity;

    
    var show = document.querySelector(".choose-cart");
    if(this.currentVariant != undefined){
     if (!this.currentVariant.available) {
          show.classList.add('show');
      } else {
          show.classList.remove('show');
      } 
    }
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.forEach(function(addBtnText){
        if (isPreOrder) {
          addBtnText.textContent = window.variantStrings.preOrder;
        }
        else if (productInventory == 1) {
          addBtnText.textContent = window.variantStrings.onlyOneLeft;
        } else {
          addBtnText.textContent = window.variantStrings.addToCart;
        }
      })
      if (text){
        addButtonText.forEach(function(addBtnText){
          addBtnText.textContent = text;
        })
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.forEach(function(addBtnText){
        if (isPreOrder) {
          addBtnText.textContent = window.variantStrings.preOrder;
        }
        else if (productInventory == 1) {
          addBtnText.textContent = window.variantStrings.onlyOneLeft;
        } else {
          addBtnText.textContent = window.variantStrings.addToCart;
        }
      })
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelectorAll('[name="add"] .p-add-cart-btn');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.forEach(function(addBtnText){
      addBtnText.textContent = window.variantStrings.unavailable;
    })
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
document.querySelectorAll('.size-btn').forEach(function(sizebtn){
  sizebtn.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('open-popup');
  });
});
if(document.querySelector('.size-popup-close') != null){
  document.querySelector('.size-popup-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-popup');
  })
}
if(document.querySelector('.product-addcart') != null){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var cartform = document.querySelector('.product-addcart').closest('form');
    const formData = new FormData(cartform);  
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.querySelector('.d-prod-error').innerHTML = window.cartStrings.quantityError;
        document.querySelector('.d-prod-error').classList.add('slide-in');
        
        setTimeout(function(e){
          document.querySelector('.d-prod-error').classList.remove('slide-in');
          document.querySelector('.d-prod-error').classList.add('slide-out');
          setTimeout(function() {
            document.querySelector('.d-prod-error').innerHTML = '';
            document.querySelector('.d-prod-error').classList.remove('slide-out');
          }, 500); // Match this duration with the slide-out animation duration
        }, 5000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
      document.querySelector('.product-addcart').classList.add('product-added')
      setTimeout(function(e){
        document.querySelector('.product-addcart').classList.remove('product-added')
      },4000);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
  
    });
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  document.querySelector('.choose-selector a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.choose-selector').classList.add('active');
    if(window.innerWidth < 641){
      doScrolling.bind(null, '#product-form-installment', 2000)
    }
  })
  // if (window.innerWidth < 641) {
  //   document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  // }
}
if(document.querySelector('.prod-sticky-init') != null){
  const ctaButtons = document.querySelectorAll('.prod-sticky-init');

  ctaButtons.forEach(button => {
    button.addEventListener('click',function(e){
      e.preventDefault();
      // if(!document.querySelector('.size-selector').classList.contains('prod-soldout')){
        document.querySelector('body').classList.add('open-select-size');
        document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant){
          if(stickyVariant.classList.contains("active")){
            stickyVariant.classList.remove("active");
          }
        })
      // }
    })
  });
}
if(document.querySelectorAll('.sticky-variant-grid') != null){
  // document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant){
  //   stickyVariant.addEventListener('click',function(e){
  //     e.preventDefault();
  //     document.querySelector('.mb-add-to-cart').setAttribute('data-id',stickyVariant.getAttribute('data-id'))
  //     if(stickyVariant.classList.contains("active")){
  //       stickyVariant.classList.remove("active");
  //       document.querySelector('.snippet-product-sticky-bar').classList.remove('active');
  //     }else{
  //       const stickyVariantsWithIsOpen = document.querySelectorAll(".sticky-variant-grid.active");
  //       stickyVariantsWithIsOpen.forEach((stickyVariantWithIsOpen) => {
  //         stickyVariantWithIsOpen.classList.remove("active");
  //         document.querySelector('.snippet-product-sticky-bar').classList.remove('active');
  //       });
  //       stickyVariant.classList.add("active");
  //       document.querySelector('.snippet-product-sticky-bar').classList.add('active');
  //     }
  //     if(stickyVariant.closest('li').classList.contains('disabled-variant')){
  //       document.querySelector('.mb-add-to-cart').classList.add('mb_soldOut','klaviyo-bis-trigger')
  //     }else{
  //       document.querySelector('.mb-add-to-cart').classList.remove('mb_soldOut','klaviyo-bis-trigger')
  //     }
  //   })
  // })
  document.querySelectorAll('.sticky-variant-grid').forEach(function(stickyVariant) {
    stickyVariant.addEventListener('click', function(e) {
      e.preventDefault();
      const mbAddToCartButtons = document.querySelectorAll('.mb-add-to-cart');
      mbAddToCartButtons.forEach(button => {
        button.setAttribute('data-id', stickyVariant.getAttribute('data-id'));
      });
  
      if (stickyVariant.classList.contains("active")) {
        stickyVariant.classList.remove("active");
        document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
          bar.classList.remove('active');
        });
      } else {
        const stickyVariantsWithIsOpen = document.querySelectorAll(".sticky-variant-grid.active");
        stickyVariantsWithIsOpen.forEach((stickyVariantWithIsOpen) => {
          stickyVariantWithIsOpen.classList.remove("active");
          document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
            bar.classList.remove('active');
          });
        });
        stickyVariant.classList.add("active");
        document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
          bar.classList.add('active');
        });
      }
  
      if (stickyVariant.closest('li').classList.contains('disabled-variant')) {
        mbAddToCartButtons.forEach(button => {
          button.classList.add('mb_soldOut', 'klaviyo-bis-trigger');
        });
      } else {
        mbAddToCartButtons.forEach(button => {
          button.classList.remove('mb_soldOut', 'klaviyo-bis-trigger');
        });
      }
    });
  });
}
const mbAddToCartButtons = document.querySelectorAll('.mb-add-to-cart');
if(mbAddToCartButtons.length > 0){
  mbAddToCartButtons.forEach(mbAddToCart => {
    mbAddToCart.addEventListener('click',function(e){
      e.preventDefault();
      if (mbAddToCart.classList.contains('mb_soldOut')) {
        // Open the Klaviyo popup and do not proceed with adding to cart
        mbAddToCart.click();
        return;
      }     
      let variant_id = mbAddToCart.dataset.id;
      let error_grid_outer = mbAddToCart.closest('.section-product');
      let error_grid = error_grid_outer.querySelector('.mb-prod-error');
      let isPreOrder = false;
      let preOrderValue = 'No';
      if (document.querySelector('.ispreordermob')) {
        isPreOrder = true;
        let productCard = document.querySelector('.ispreordermob');
        if (productCard) {
          preOrderValue = productCard.getAttribute('data-preorder');
        }
      }
      let formData = {
        'items': [{
          'id': variant_id,
          'quantity': 1,
          'properties': {"Pre-order item": "No"},
        }]
      };

      if (isPreOrder) {
        formData.items[0].properties = {"Pre-order item": preOrderValue};
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        if(data.status == 422){
          error_grid.innerHTML = window.cartStrings.quantityError;
          error_grid.classList.add('slide-in');

          setTimeout(function(e){
            error_grid.classList.remove('slide-in');
            error_grid.classList.add('slide-out');
            setTimeout(function() {
              error_grid.innerHTML = '';
              error_grid.classList.remove('slide-out');
            }, 500);
          }, 5000);
        }else{          
          if(document.location.href.indexOf('/cart') > -1) {
            window.location.href = "/cart";
          }else{
            if(typeof load_cart == 'function'){
              load_cart();
              setTimeout(function(e){
                document.querySelector('body').classList.remove('open-select-size');
                document.querySelector('body').classList.add('open-mb-cart');
                document.querySelectorAll('.snippet-product-sticky-bar').forEach(bar => {
                  bar.classList.remove('active');
                });
                setTimeout(function(e){
                  document.querySelector('body').classList.remove('open-mb-cart');
                },4000);
              },500);
            }else{
              window.location.href = "/cart";
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
    })
  });
}
const mbCartDrawerButtons = document.querySelectorAll('.mb-cart-drawer');
if (mbCartDrawerButtons.length > 0) {
  mbCartDrawerButtons.forEach(mbCartDrawer => {
    mbCartDrawer.addEventListener('click',function(e){
      e.preventDefault();
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          document.querySelector('body').classList.add('open-drawer');
        }        
      }
    })
  });
}
function stickyScroll(){
  const ctaButtonBelowColors = document.querySelector('.mobile-cta-below-colors');
  const fixedCtaButton = document.querySelector('.mobile-cta-fixed-button');
  window.addEventListener('scroll', (e)=>{
    let scroll = window.scrollY;
    // let height = document.getElementById('shopify-section-footer').offsetTop - window.outerHeight
    // if(scroll >= height){
    //   document.querySelector('body').classList.remove('stickybar');
    //   document.querySelector('body').classList.remove('open-select-size');
    //   document.querySelector('.snippet-product-sticky-bar').classList.remove('active');
    // }else{
    //   document.querySelector('body').classList.add('stickybar');
    // }
    let buttonPosition = ctaButtonBelowColors.getBoundingClientRect().top + window.scrollY;
    let windowHeight = window.innerHeight;

    if (scroll + windowHeight >= buttonPosition && scroll <= buttonPosition + ctaButtonBelowColors.offsetHeight) {
      document.querySelector('body').classList.remove('stickybar');
      document.querySelector('body').classList.remove('open-select-size');
    } else {
      document.querySelector('body').classList.add('stickybar');
    }
  });
}
stickyScroll();
document.addEventListener("DOMContentLoaded", () => {
  stickyScroll();
});
if(document.querySelector('.size-popup-close') != null){
  document.querySelector('.size-popup-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-popup');
  })
}
addEventListener("DOMContentLoaded", (event) => {
  document.querySelector('.prod-content').style.maxHeight = document.querySelector('.prod-content .prod-content-inr').clientHeight+'px'
});
function updSwiperNumericPagination(){
  document.querySelector(".prod-counter").innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + this.slides.length + "</span>";
}
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 991) {
    if (!init) {
      init = true;
      swiper = new Swiper(".media-grid.swiper", {
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: true,
        navigation: {
          nextEl: ".prod-arrows.swiper-button-next",
          prevEl: ".prod-arrows.swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          init: updSwiperNumericPagination,
          slideChange: updSwiperNumericPagination
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
function boxHeight(){
  document.querySelector('.media-thumb-cursor').style.height = (100 * window.innerHeight) / document.querySelector('.product-media').clientHeight + '%'
}
addEventListener("DOMContentLoaded", boxHeight)
addEventListener("resize", boxHeight)
window.addEventListener('scroll', (e)=>{
  let scrollDistance = window.pageYOffset
  if(scrollDistance > 0){
    document.querySelector('.prod-content').style.maxHeight = '0px'
    document.querySelector('.section-product').classList.add('scroll-start')
  }else{
    document.querySelector('.prod-content').style.maxHeight = document.querySelector('.prod-content .prod-content-inr').clientHeight+'px'
    document.querySelector('.section-product').classList.remove('scroll-start')
  }
  let mediaCount = document.querySelectorAll('.media-thumb').length
  var mainScroll = (scrollDistance / (document.querySelector('.product-media').clientHeight - window.innerHeight)) * 100;
  var thumbScroll = (scrollDistance / (document.querySelector('.prod-thumb-inr .medialist').clientHeight - window.innerHeight)) * 100;
  let mainCurrent = parseFloat(((scrollDistance / document.querySelector('.product-media').clientHeight) * 100).toFixed(2))
  let thumbCurrent = parseFloat((((scrollDistance + document.querySelector('.media-thumb-cursor').clientHeight) / document.querySelector('.prod-thumb-inr .medialist').clientHeight) * 100).toFixed(2))
  if(mainScroll <= 100){
    document.querySelector('.media-thumb-cursor').style.top = mainCurrent +'%'
  }
})
// if(document.querySelector('.prod-thumb-inr .medialist')){
//   document.querySelector('.prod-thumb-inr .medialist').addEventListener('click',function(e){
//     document.querySelector('html').style.scrollBehavior = 'unset'
//     let top = (e.clientY - this.offsetTop)/(this.clientHeight/100)
//     document.querySelector(".media-thumb-cursor").style.top = top+'%'
//     document.scrollingElement.scrollTop = (document.querySelector('.product-media').clientHeight/100)*top
//   });
// }
var parentBox = document.getElementById('mediaThumbDragParent');
var box = document.getElementById('mediaThumbDragBox');
// Variables to track if mouse is down (clicked) or up
var isMouseDown = false;
// Variables to store initial mouse position and box position in percentages
var initialMouseX, initialMouseY, initialBoxX, initialBoxY;
// Add event listeners
box.addEventListener('mousedown', handleMouseDown);
document.addEventListener('mouseup', handleMouseUp);
document.addEventListener('mousemove', handleMouseMove);
function handleMouseDown(event){
  // Mark the mouse as being down
  isMouseDown = true;
  // Record the initial mouse coordinates
  initialMouseX = event.clientX;
  initialMouseY = event.clientY;
  // Convert the box's position to percentage of the parentBox's dimensions
  initialBoxX = box.offsetLeft / parentBox.offsetWidth * 100;
  initialBoxY = box.offsetTop / parentBox.offsetHeight * 100;
}
function handleMouseUp(){
  // Mark the mouse as being up
  isMouseDown = false;
}
function handleMouseMove(event){
  if(!isMouseDown){
    return;
  }
  // Calculate the difference in position
  var deltaX = (event.clientX - initialMouseX) / parentBox.offsetWidth * 100;
  var deltaY = (event.clientY - initialMouseY) / parentBox.offsetHeight * 100;
  // Calculate new position in percentages
  var newLeft = initialBoxX + deltaX;
  var newTop = initialBoxY + deltaY;
  // Calculate the box's own dimensions as percentages of the parent box
  var boxWidthPct = box.offsetWidth / parentBox.offsetWidth * 100;
  var boxHeightPct = box.offsetHeight / parentBox.offsetHeight * 100;
  // Prevent the box from moving outside the parentBox
  newLeft = Math.max(Math.min(newLeft, 100 - boxWidthPct), 0);
  newTop = Math.max(Math.min(newTop, 100 - boxHeightPct), 0);
  // Apply the new position
  box.style.left = newLeft + '%';
  box.style.top = newTop + '%';
  const getSectionHeight = document.querySelector('.product-wrap').offsetHeight / 100;
//  window.scrollTo({top: (getSectionHeight*newTop),behavior: "auto"});
  document.documentElement.scrollTop = getSectionHeight * newTop;
}
if(document.querySelector('.prod-thumb-inr .medialist')){
  document.querySelector('.prod-thumb-inr .medialist').addEventListener('dblclick',function(e){
    document.querySelector('html').style.scrollBehavior = 'unset'
    let top = (e.clientY - this.offsetTop)/(this.clientHeight/100)
      document.querySelector(".media-thumb-cursor").style.top = top+'%'
      document.scrollingElement.scrollTop = (document.querySelector('.product-media').clientHeight/100)*top
  });
}


document.addEventListener("DOMContentLoaded", () => {
  const stickyVariantGrids = document.querySelectorAll('.sticky-variant-grid');
  const mbAddedElements = document.querySelectorAll('.mb-added:not(.product-sticky-bar-btm .mb-added)');


  stickyVariantGrids.forEach(stickyVariantGrid => {
    stickyVariantGrid.addEventListener('click', function(event) {
      event.preventDefault();
      const productInventoryMob = this.getAttribute('inventory');      
      mbAddedElements.forEach(mbAdded => {
      if (isPreOrder) {
        mbAdded.textContent = window.variantStrings.preOrder;
      } 
      else if (productInventoryMob == 1) {
        mbAdded.textContent = window.variantStrings.onlyOneLeft;
      }
      else {
        mbAdded.textContent = window.variantStrings.addToCart;
      }
      });
    });
  });
});